// Surface — the base card chrome every visual block sits on. Token-driven
// background / radius / shadow / border; theme- and card-style-aware via the
// CSS variables in variables.css. Reusability 10/10: used on every screen.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './surface.css';

const PAD = { none: 'none', sm: 'sm', md: 'md', lg: 'lg' };

export function Surface({
  as: Tag = 'div',
  variant = 'elevated',
  padding = 'md',
  interactive = false,
  className,
  children,
  ...rest
}) {
  return (
    <Tag
      className={cx(
        'surface',
        variant !== 'elevated' && `surface--${variant}`,
        `surface--p-${PAD[padding] || 'md'}`,
        interactive && 'surface--interactive',
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}

Surface.propTypes = {
  /** Element or component to render as. */
  as: PropTypes.elementType,
  /** Visual treatment. Defaults to the global card style; override per instance. */
  variant: PropTypes.oneOf(['elevated', 'inset', 'outlined', 'flat']),
  /** Inner padding step. */
  padding: PropTypes.oneOf(['none', 'sm', 'md', 'lg']),
  /** Adds hover affordance (lift + cursor) for clickable cards. */
  interactive: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Surface;
